import { useLocale } from '@/contexts/LocaleContext';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useHubTabs } from '@/lib/permisos';
import { MessageCircle, Home, Send, FileText, BarChart3, Link2 } from 'lucide-react';

/**
 * S176 — Solo WhatsApp masivo + conexión. QR de captación → Marketing.
 */
const TABS = [
  { to: '/tenant/whatsapp', end: true, labelKey: 'wa.home', icon: Home, module: 'marketing' },
  { to: '/tenant/whatsapp/conexion', labelKey: 'wa.connection', icon: Link2, module: 'marketing' },
  { to: '/tenant/whatsapp/envios', labelKey: 'wa.sends', icon: Send, module: 'marketing' },
  { to: '/tenant/whatsapp/plantillas', labelKey: 'wa.templates', icon: FileText, module: 'marketing' },
  { to: '/tenant/whatsapp/informes', labelKey: 'wa.reports', icon: BarChart3, module: 'marketing' },
];

export default function WhatsAppHubLayout() {
  const { t } = useLocale();
  const navigate = useNavigate();
  const { tabs: visibleTabs } = useHubTabs(TABS);

  return (
    <div className="space-y-4" data-testid="whatsapp-hub">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-lg font-bold text-[#0F172A] flex items-center gap-2">
            <MessageCircle className="w-5 h-5 text-[#128C7E]" /> WhatsApp
          </h1>
          <p className="text-sm text-[#64748B]">
            Envíos masivos con plantillas aprobadas. Los <strong>códigos QR</strong> de captación están en{' '}
            <button type="button" className="text-[#128C7E] font-medium underline-offset-2 hover:underline"
              onClick={() => navigate('/tenant/marketing/qr-campaigns')}>
              Marketing → Códigos QR
            </button>
            .
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/tenant/whatsapp/envios')}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-[#128C7E] text-white text-xs font-semibold hover:bg-[#0f7a6c]"
        >
          <Send className="w-3.5 h-3.5" /> Nuevo envío
        </button>
      </div>

      <div className="flex gap-1 border-b border-[#E2E8F0] overflow-x-auto" data-testid="wa-hub-tabs">
        {visibleTabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            data-testid={`wa-tab-${tab.to.split('/').pop() || 'home'}`}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3 py-2.5 text-xs font-medium border-b-2 whitespace-nowrap ${
                isActive ? 'border-[#128C7E] text-[#0F172A]' : 'border-transparent text-[#64748B] hover:text-[#0F172A]'
              }`
            }
          >
            <tab.icon className="w-3.5 h-3.5" />
            {tab.labelKey ? t(tab.labelKey) : tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
